import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

BankCard.propTypes = {
    item: PropTypes.object,
    onEdit: PropTypes.func,
    disabledEditBank: PropTypes.bool,
};

function BankCard(props) {
    // MARK: ---- PROPERTIES ----
    const { item, onEdit, disabledEditBank } = props;
    const { t } = useTranslation();

    const handleEdit = () => {
        if (onEdit) {
            onEdit();
        }
    }

    return (
        <div
            className="overflow-hidden position-relative"
            style={{
                borderLeft: `1px solid ${AppColors.gray[300]}`,
                borderTop: `1px solid ${AppColors.gray[300]}`,
                borderRight: `1px solid ${AppColors.gray[300]}`,
                borderBottom: `5px solid ${item?.defaultAccount ? AppColors.primary : AppColors.gray[300]}`,
                borderRadius: '10px',
            }}
        >
            <div
                style={{
                    backgroundColor: AppColors.gray[100],
                    borderBottomLeftRadius: '10px',
                    borderBottomRightRadius: '10px',
                }}
            >
                <div className="pr-3 pt-3 pl-5">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                            <div
                                className="fw-semibold"
                                style={{
                                    fontSize: '18px',
                                    color: AppColors.gray[800],
                                }}
                            >
                                {item?.defaultAccount ? 'Tài khoản mặc định' : 'Tài khoản'}
                            </div>

                            {item?.status === 'LOCKED' && (
                                <span className="min-w-100px">
                                    <KTLabel
                                        text={t(`agencyBankStatus_${item?.status}`)}
                                        isInline={true}
                                        size={KTLabelSize.medium}
                                        additionalClassName="label-light-danger"
                                    />
                                </span>
                            )}
                        </div>

                        <div style={{ zIndex: 2 }}>
                            <VITableRowDropDown
                                toggleElement={
                                    <a
                                        href="#"
                                        className="btn btn-sm btn-icon h-45px w-45px bg-white"
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        <i
                                            className="fa-solid fa-ellipsis"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        />
                                    </a>
                                }
                                menuItem={[
                                    {
                                        iconElement: <i className="fa-regular fa-pen-to-square" />,
                                        text: t('edit'),
                                        click: handleEdit,
                                        show: !item?.defaultAccount || !disabledEditBank,
                                    },
                                ]}
                                singleBtnBgColor="#fff"
                            />
                        </div>
                    </div>
                    <div className='pb-3' style={UIHelper.buildFontStyle('700', '26px', item?.defaultAccount ? AppColors.primary : AppColors.gray[500])}>
                        {item?.bankAccount}
                    </div>
                    <div style={{ borderBottom: `1px dashed ${AppColors.gray[300]}` }} />
                </div>
                <div className="px-5 py-4">
                    <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}>Ngân hàng: </span>
                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>{item?.bankName}</span>
                </div>
            </div>

            <div
                className="position-absolute rounded-circle"
                style={{
                    width: '100px',
                    height: '100px',
                    top: '0px',
                    right: '0px',
                    zIndex: 1
                }}
            >
                <img src={AppResource.icons.tmt.bankIcon} />
            </div>
        </div>
    );
}

export default BankCard;
